<section class="contact">
  <div class="bg-form">
    <div class="container">
      <h2 class="text-center">Дополнительно</h2>
      <p class="text-center"></p>
      <div class="animatedParent">
        <div class="row">
          <div class="animated bounceInLeft">
            <div class="animatedParent">
              <div class="container">
                <div class="info-plan">
                  <div class="container">
                    <div class="row">
                      <div class="col-md-12 animated bounceInLeft">
                        <div class="text-center">
                          <img src="assets/images/powerfull.svg" alt="improving">
                          <h5>Дополнительная информация</h5>
                        </div>




                        <p class="pb-2 mb-2">ООО "ТЕЛЕКОМ - ОРЕЛ" в рамках предоставления IP телевидения (цифрового телевидения) действует в качестве Агента.Услуга предоставляется ООО "Медиаоператор", торговая марка Moovi.
                          <a class="btn-link" target="_blank" href="/assets/file/dov.pdf">Доверенность</a></p>
                        <div>
                          <h6> Договор на оказание услуг связи для целей телевизионного вещания: <a class="d-inline-block" target="_blank" href="/assets/file/obr.pdf"> скачать образец абонентского договора</a></h6>
                          <h6> Политика конфидециальности: <a class="d-inline-block" target="_blank" href="/assets/file/konf.pdf"> скачать политику конфидециальности</a></h6>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div><!--container-->
            </div>
          </div>
        </div>
      </div><!--info-block-contact-->
    </div>
  </div>
</section>

